import { render, staticRenderFns } from "./logform.vue?vue&type=template&id=c5d5deac&scoped=true"
import script from "./logform.vue?vue&type=script&lang=js"
export * from "./logform.vue?vue&type=script&lang=js"
import style0 from "./logform.vue?vue&type=style&index=0&id=c5d5deac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d5deac",
  null
  
)

export default component.exports